import React from "react";

const EmailVerificationAlert = ({ onClose }) => {
	return (
		<div className="fixed z-50 inset-0 flex items-center justify-center">
			<div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-lg">
				<div className="text-center">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-12 w-12 mx-auto text-green-500">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
					</svg>
					<h2 className="text-2xl font-semibold text-gray-800 mb-4">Check Your Email</h2>
					<p className="text-gray-600 mb-4">We've sent a confirmation link to your email. Please check your inbox and follow the link to complete the process.</p>
					<button onClick={onClose} className="bg-red-400 text-white px-4 py-2 rounded-md hover:bg-red-600 focus:outline-none focus:ring focus:border-green-300">
						Close
					</button>
				</div>
			</div>
		</div>
	);
};

export default EmailVerificationAlert;
